import { createSlice } from '@reduxjs/toolkit';
import { createNewLayoutThunk, getAllLayoutThunk, updateExistingLayoutThunk } from './layoutAction';
import { isEmpty } from 'lodash';

export interface LayoutState {
  loading: boolean;
  configData: any;
}

const initialState: LayoutState = {
  loading: false,
  configData: {},
};

const layoutSlice = createSlice({
  name: 'Layout',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllLayoutThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllLayoutThunk.fulfilled, (state, action: any) => {
        const actionRes = action && action.payload;
        const screenId = !isEmpty(actionRes) && actionRes[0].screenId;
        let configData = { ...state.configData };
        if (screenId) {
          configData[screenId] = !isEmpty(actionRes) ? actionRes : [];
        }
        state.loading = false;
        state.configData = configData;
      })
      .addCase(getAllLayoutThunk.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createNewLayoutThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(createNewLayoutThunk.fulfilled, (state, action: any) => {
        const actionResp = action && action.response && action.response.data;
        const createdScreenId = !isEmpty(actionResp) && actionResp.screenId;
        let configData1 = { ...state.configData };
        if (createdScreenId) {
          configData1[createdScreenId] = action.response.data ? [action.response.data] : {};
        }
        state.loading = false;
        state.configData = configData1;
      })
      .addCase(createNewLayoutThunk.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateExistingLayoutThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateExistingLayoutThunk.fulfilled, (state, action: any) => {
        const actionRespn = action && action.response && action.response.data;
        const updatedScreenId = !isEmpty(actionRespn) && actionRespn.screenId;
        let configData2 = { ...state.configData };
        if (updatedScreenId) {
          configData2[updatedScreenId] = action.response.data ? [action.response.data] : {};
        }
        state.loading = false;
        state.configData = configData2;
      })
      .addCase(updateExistingLayoutThunk.rejected, (state) => {
        state.loading = false;
      });
  },
});

// export const {} = layoutSlice.actions;
export default layoutSlice.reducer;

// case GET_ALL_DATAVISUALIZATION_DETAILS_NEW.triggered:
// 	return {...state, loading: true}

// case GET_ALL_DATAVISUALIZATION_DETAILS_NEW.succeeded:
// 	const actionRes = action && action.response && action.response.data
// 	const screenId = !isEmpty(actionRes) && actionRes[0].screenId
// 	let configData = {...state.configData}
// 	if (screenId) {
// 		configData[screenId] = action.response.data ? action.response.data : {}
// 	}
// 	return {
// 		...state,
// 		loading: false,
// 		configData,
// 	}

// case GET_ALL_DATAVISUALIZATION_DETAILS_NEW.failed:
// 	return {...state, loading: false}

// case CREATE_DATAVISUALIZATION_DETAILS_NEW.triggered:
// 	return {...state, loading: true}

// case CREATE_DATAVISUALIZATION_DETAILS_NEW.succeeded:
// 	const actionResp = action && action.response && action.response.data
// 	const createdScreenId = !isEmpty(actionResp) && actionResp.screenId
// 	let configData1 = {...state.configData}
// 	if (createdScreenId) {
// 		configData1[createdScreenId] = action.response.data ? [action.response.data] : {}
// 	}
// 	return {
// 		...state,
// 		loading: false,
// 		configData: configData1,
// 	}

// case CREATE_DATAVISUALIZATION_DETAILS_NEW.failed:
// 	return {...state, loading: false}

// case UPDATE_DATAVISUALIZATION_DETAILS_NEW.triggered:
// 	return {...state, loading: true}

// case UPDATE_DATAVISUALIZATION_DETAILS_NEW.succeeded:
// 	const actionRespn = action && action.response && action.response.data
// 	const updatedScreenId = !isEmpty(actionRespn) && actionRespn.screenId
// 	let configData2 = {...state.configData}
// 	if (updatedScreenId) {
// 		configData2[updatedScreenId] = action.response.data ? [action.response.data] : {}
// 	}
// 	return {
// 		...state,
// 		loading: false,
// 		configData: configData2,
// 	}

// case UPDATE_DATAVISUALIZATION_DETAILS_NEW.failed:
// 	return {...state, loading: false}
